import React, { useState } from "react";
import OTPInput from "react-otp-input";
import { Spinner } from "reactstrap";
import { CustomSnackbar } from "../../../helpers/CustomSnackbar";
import { Link, useNavigate } from "react-router-dom";
import { apiErrorHandler } from "../../../helpers/common";
import { verifyMobileForgotPasswordOtp, forgetPassword } from "../../../api/customer";
import PropTypes from "prop-types";

const VerifyMobile = ({
  formData,
  showLoginBtn = true,
}) => {
  const [otp, setOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [remainingTime, setRemainingTime] = useState(60);
  const navigate = useNavigate();

  React.useEffect(() => {
    const timer = setInterval(() => {
      setRemainingTime((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleVerifyMobile = async () => {
    if (!otp) {
      CustomSnackbar.error("Please enter OTP!");
      return;
    }

    if (otp?.length < 6) {
      CustomSnackbar.error("Invalid OTP!");
      return;
    }

    setIsLoading(true);
    try {
      const payload = {
        mobile_number: formData?.mobile_number,
        mobile_verification_otp: otp,
      };

      const response = await verifyMobileForgotPasswordOtp(payload);

      if (response?.data?.message) {
        CustomSnackbar.success(response?.data?.message);
        navigate("/signin");
      }
    } catch (error) {
      apiErrorHandler(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOTP = async () => {
    if (remainingTime > 0) return;
    
    setResendLoading(true);
    try {
      const response = await forgetPassword({ mobile_number: formData?.mobile_number });
      CustomSnackbar.success(response?.data?.message || "OTP sent successfully!");
      setRemainingTime(60);
    } catch (error) {
      apiErrorHandler(error);
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div className='w-100 verification-container'>
      <div className='verification-card'>
        <div className='text-center mb-4'>
          <h4 className='verification-title'>Verify Mobile OTP</h4>
          <p className='verification-subtitle'>
            An OTP has been sent to your mobile number <b>{formData?.mobile_number}</b>.
          </p>
        </div>

        <div className="otp-container">
          <OTPInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            renderSeparator={<span style={{ margin: 4 }}>-</span>}
            containerStyle={{ 
              display: "flex", 
              justifyContent: "center", 
              alignItems: "center", 
              flexWrap: "nowrap",
              gap: "3px",
              marginBottom: "15px",
              padding: "0 5px",
              maxWidth: "100%"
            }}
            inputType='number'
            renderInput={(props) => (
              <input
                {...props}
                className={`otp-input`}
                style={{ flexShrink: 0 }}
              />
            )}
          />
        </div>

        <div className='resend-otp-container'>
          <div
            style={{
              textAlign: "center",
              marginTop: 10,
              fontSize: 14,
              color: "#fff",
            }}
          >
            {remainingTime === 0 ? (
              <div
                onClick={handleResendOTP}
                style={{
                  cursor: "pointer",
                  display: "inline-flex",
                  gap: 6,
                  alignItems: "center",
                }}
              >
                {resendLoading && <Spinner size="sm" />} Resend OTP
              </div>
            ) : (
              <>
                You can resend the OTP in
                <span> {remainingTime} secs</span>
              </>
            )}
          </div>
        </div>

        <div className='text-center mt-4'>
          {isLoading ? (
            <button
              className='verify-btn w-50 disabled'
              type='button'
              disabled
            >
              <Spinner size="sm" className="me-2" />
              Verify Mobile
            </button>
          ) : (
            <button
              className='verify-btn w-50'
              type='button'
              onClick={handleVerifyMobile}
            >
              Verify Mobile
            </button>
          )}
        </div>

        {showLoginBtn && (
          <div className='text-center mt-3'>
            <Link to='/signin' className='resend-otp-button'>
              Go to login
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

VerifyMobile.propTypes = {
  formData: PropTypes.object,
  showLoginBtn: PropTypes.bool,
};

export default VerifyMobile; 